import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import axios from "axios";
import Swal from 'sweetalert2';

function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");
  const navigate = useNavigate();
  const [isLogoSet, SetIsLogoSet] = useState(false);

  const handleSuccess = (msg) => {
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
    function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          id: Math.floor(Math.random() * 100000),
          email: `${randomString}@gmail.com`,
          userId: randomString,
          firstName: randomString,
          lastName: randomString,
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          gameId: `game${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass",
          organizationId: "demobypass"
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        const headers = {
          'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        
        const method = "POST";
        if (["POST", "PUT"].includes(method)) {
          headers["Idempotency-Key"] = uuidv4();
          console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
        }

        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    let companyLogo = process.env.REACT_APP_S3BUCKET_URL + '/' + responseOrg.data.organization.companyLogo;
                    console.log("companyLogo", companyLogo);

                    if (typeof updateHeader === "function") {
                      updateHeader({
                        imageUrl: companyLogo,
                        backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                      });
                    } else {
                      console.warn("updateHeader prop is not provided to Login");
                    }
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                });
                console.log(response);
              loginCheck(response, source);
            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  function loginCheck(response, source) {

    console.log(response.data.data.organizationId);

    const userId = role === 'GUEST_USER'
      ? response.data.data.id
      : response.data.data.userId;

    let name = `${response.data.data.firstName} ${response.data.data.lastName}`;
    let email;
  
    if (role === 'GUEST_USER' && (response.data.data.firstName === "" ||response.data.data.firstName === null)) {
      //alert(response.data.data.employeeId);
      if (response.data.data.email) {
        // Extract the part before '@' in the email (email has priority)
        name = response.data.data.email.split('@')[0];
        email = response.data.data.email;
        
      } else if (response.data.data.employeeId) {
        // Use employeeId as name if email is not present (although email will be present as per your note)
        name = response.data.data.employeeId;
        email = response.data.data.employeeId;
        //alert(name);
      } else {
        name = 'Guest'; // Fallback name if both email and employeeId are unavailable
      }
    }else if (role === 'GUEST_USER' && response.data.data.firstName != "") {

      if (response.data.data.email) {
        // Extract the part before '@' in the email (email has priority)
        name = response.data.data.firstName;
        email = response.data.data.email;

      } else if (response.data.data.employeeId) {
        // Use employeeId as name if email is not present (although email will be present as per your note)
        name = response.data.data.firstName;
        email = response.data.data.employeeId;
      } else {
        name = response.data.data.firstName; // Fallback name if both email and employeeId are unavailable
      }
    } else {
      email = response.data.data.email;
    }

    const userData = {
      userId: userId,
      sessionId: response.data.data.sessionId,
      organizationId: response.data.data.organizationId,
      name: name,
      email: email,
      expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
      source: source,
      gameId: response.data.data.gameId,
      token: response.data.data.token || "",
      fromMobileApp: sessionStorage.getItem("fromMobileApp") === "true",
    };
    console.log("userData",userData);

    sessionStorage.setItem('userData', JSON.stringify(userData));

    // Reference to the user's document inside the session's users collection
    const userDocRef = doc(
      database,
      `sessions/${userData.sessionId}/users/${userData.userId}`
    );

    // Check if the user already exists
    getDoc(userDocRef)
      .then((userSnapshot) => {
        if (userSnapshot.exists()) {
          setIsLoggedIn(true);
          console.log("Current user already exists! Ignoring update...");
          if (queryParams.get('admin')) {
            window.location.href = process.env.REACT_APP_ADMIN_REDIRECT + '?sessionId=' + response.data.data.sessionId + "&userId=" + userId + "&organizationId=" + response.data.data.organizationId+ "&gameId=" + response.data.data.gameId;
          }
        } else {
          // If the user doesn't exist, add a new document

          setDoc(userDocRef, {
            userId: userData.userId,
            organizationId: userData.organizationId,
            sessionId: userData.sessionId,
            name: userData.name,
            email: userData.email,
            timestamp: Date.now(),
            source: source,
            gameId: response.data.data.gameId,
            token: response.data.data.token || "",
          })
            .then(() => {
              console.log("User document created successfully");
              // Redirect after successfully creating the document
              if (queryParams.get('admin')) {
                window.location.href = `${process.env.REACT_APP_ADMIN_REDIRECT}?sessionId=${response.data.data.sessionId}&userId=${userId}&organizationId=${response.data.data.organizationId}&gameId=${response.data.data.gameId}`;
              }
            })
            .catch((error) => {
              console.error("Error creating user document:", error);
              handleError("There was an error creating your user document. Please try again.");
            });
        }

        const themeApiBase = process.env.REACT_APP_FETCH_THEMEDATA || "";
        const isAbsoluteThemeApi = /^https?:\/\//i.test(themeApiBase);
        const resolvedThemeUrl = new URL(themeApiBase, window.location.origin);
        resolvedThemeUrl.searchParams.set("sessionId", response.data.data.sessionId);
        resolvedThemeUrl.searchParams.set("userId", userId);
        resolvedThemeUrl.searchParams.set("organizationId", response.data.data.organizationId);

        // In local dev, call through CRA proxy to avoid browser CORS blocks.
        const themeRequestUrl =
          process.env.NODE_ENV === "development"
            ? `${resolvedThemeUrl.pathname}${resolvedThemeUrl.search}`
            : isAbsoluteThemeApi
              ? resolvedThemeUrl.toString()
              : `${resolvedThemeUrl.pathname}${resolvedThemeUrl.search}`;

        console.log(themeRequestUrl);
        fetch(themeRequestUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((json) => {
            setThemeData(json);
            sessionStorage.setItem('themeData', JSON.stringify(json));
            CheckThemeSet(response.data.data.sessionId, json.form_default, json.themeName);
            console.log(json);
          })
          .catch((err) => {
            console.log(err.message); // Handle error
          });
      })
      .catch((error) => {
        handleError("Login failed! Please try again.");
        console.error("Error processing user data:", error);
      });

  }

  async function CheckThemeSet(sessionId, themedataarray, themeName) {

    if (!themedataarray || themedataarray.length === 0) {
      console.error("themedataarray data is empty or undefined. Cannot proceed.");
      return;
    }

    const gameRef = doc(database, `sessions/${sessionId}/themes/${themeName}`);

    try {
      // Get the document snapshot
      const docSnapshot = await getDoc(gameRef);

      if (docSnapshot.exists()) {
        const gameData = docSnapshot.data();
        console.log("Game Data:", gameData);
        setIsLoggedIn(true);
        console.log("isLoggedIn", isLoggedIn);
      } else {
        console.warn("Game session document does not exist. Creating new session...");

        // Create the document with default values if it doesn't exist
        await setDoc(gameRef, {
          ...themedataarray,
          sessionId,
          date: serverTimestamp(), // ✅ Adds timestamp
        });
        setIsLoggedIn(true);
        console.log("New game session document created.");


      }
    } catch (error) {
      console.error("Error checking or creating game session document:", error);
    }

  }


  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {
    if (themeData) {
      const body = document.body;

      const backgroundImage = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${backgroundImage})`;
      }
      setRiddlerusLogo(themeData.logo);
      SetIsLogoSet(true);
    }
  }, [themeData]);

  return (
    <>
      <div className="login-main-container" style={{ textAlign: "center" }}>

        {
          (isLogoSet) ?
            <div className="login-main-container2" style={{ textAlign: "center" }}>
              <img src={riddlerusLogo} className="login-logo" />
            </div>
            :
            <>
              <div className="loader">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            </>

        }
        {isLoggedIn ? (
          <div style={{ textAlign: "center" }}>
            <Link to="/intro">
              <img src="/img/begin-play.png" className="begin-play-img1" alt="Begin Play" />
            </Link>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default Login;
